export const ModifiedFields = {
  SPACING: ['Spacing'],
  QUANTITY: ['Quantity'],
  CLEAN_UP: ['CleanUp'],
  PRODUCT: ['Product'],
  DELIVERY_DATE: ['DeliveryDate'],
  DELIVERY_TIME: ['DeliveryTime'],
  CONTACT: ['Contact'],
  INSTRUCTIONS: ['Instructions'],
  PURCHASE_ORDER: ['PurchaseOrder'],
  APPLICATION: ['Application'],
  LOAD_SIZE: ['LoadSize'],
  SLUMP: ['Slump'],
  CONTRACT: ['Contract'],
  POD: ['PointOfDelivery'],
  PLANT: [
    'Plant',
    'ToJobTravelTime',
    'ToPlantTravelTime',
    'Distance',
  ],
  VALUE_ADDED: ['ValueAdded'],
};
